/**
 * アカウントの復旧（H-10）・コードでのパスワード再設定・監査ログの操作名（M-12）の文言。
 * 未認証の画面（pwr.*）には防御の詳細（ロックの閾値・試行回数・パスワードの最小長）を出さない。
 */
export const ja: Record<string, string> = {
  "rnotice.title": "アカウントの復旧が行われました",
  "rnotice.PASSWORD_RESET": "{name}さんが {time} にパスワードを再設定しました。心当たりが無ければセキュリティ担当部署長に連絡してください。",
  "rnotice.UNLOCK": "{name}さんが {time} にアカウントのロックを解除しました。心当たりが無ければセキュリティ担当部署長に連絡してください。",
  "rnotice.TOTP_RESET": "{name}さんが {time} に認証アプリの登録をリセットしました。心当たりが無ければセキュリティ担当部署長に連絡してください。",
  "rnotice.serverSide": "{time} にサーバでの手順でパスワードが再設定されました。すぐ「設定」でパスワードを変更してください。心当たりが無ければセキュリティ担当部署長に連絡してください。",
  "rnotice.ok": "確認しました",
  "errc.RESET_CODE_PENDING_APPROVAL": "このコードは、まだ別の担当者の承認を受けていません。承認されたら、同じコードでもう一度送ってください（入力は残っています）。",
  "errc.RESET_CODE_INVALID": "コードかメールアドレスが違うか、コードの期限（24時間）が切れています。もう一度確かめるか、セキュリティ担当部署長にコードを発行し直してもらってください。",
  "pwr.link": "コードでパスワードを再設定",
  "pwr.title": "コードでパスワードを再設定",
  "pwr.intro": "セキュリティ担当部署長から伝えられた再設定コードを使って、新しいパスワードを決めます。",
  "pwr.email": "メールアドレス",
  "pwr.code": "再設定コード",
  "pwr.codeHint": "大文字・小文字やハイフンの有無は気にしなくて大丈夫です。",
  "pwr.new": "新しいパスワード",
  "pwr.newHint": "ほかのサービスと同じものは避け、推測されにくいパスワードにしてください。条件に合わないときは、この欄の下に理由が出ます。",
  "pwr.confirm": "新しいパスワード（もう一度）",
  "pwr.sep": "。",
  "pwr.submit": "パスワードを設定する",
  "pwr.submitting": "設定中…",
  "pwr.back": "ログイン画面へ戻る",
  "pwr.err.emailRequired": "メールアドレスを入力してください",
  "pwr.err.codeRequired": "再設定コードを入力してください",
  "pwr.err.newRequired": "新しいパスワードを入力してください",
  "pwr.err.mismatch": "上の欄と同じパスワードを入れてください",
  "pwr.err.invalid": "コードかメールアドレスが違うか、コードの期限（24時間）が切れています。もう一度確かめるか、セキュリティ担当部署長にコードを発行し直してもらってください。入力は残っています。",
  "pwr.err.policy": "パスワードが条件に合いません。直す場所は「新しいパスワード」の下に書いてあります。入力は残っています。",
  "pwr.err.rate": "短い時間に何度も試されたので、少し待っています。しばらくしてから、もう一度「パスワードを設定する」を押してください。入力は残っています。",
  "pwr.err.network": "サーバーに接続できませんでした。入力は残っています。通信を確かめて、もう一度「パスワードを設定する」を押してください。",
  "pwr.err.other": "パスワードを設定できませんでした。入力は残っています。しばらくしてからもう一度試すか、セキュリティ担当部署長に連絡してください。",
  "pwr.done": "パスワードを設定しました。新しいパスワードでログインしてください。ログイン後に案内が出ることがあります。",
};

export const en: Record<string, string> = {
  "rnotice.title": "Your account was recovered",
  "rnotice.PASSWORD_RESET": "{name} reset your password on {time}. If you did not expect this, contact the security department head.",
  "rnotice.UNLOCK": "{name} unlocked your account on {time}. If you did not expect this, contact the security department head.",
  "rnotice.TOTP_RESET": "{name} reset your authenticator app registration on {time}. If you did not expect this, contact the security department head.",
  "rnotice.serverSide": "Your password was reset by the server-side procedure on {time}. Change it now in Settings. If you did not expect this, contact the security department head.",
  "rnotice.ok": "Got it",
  "errc.RESET_CODE_PENDING_APPROVAL": "This code has not been approved by a second administrator yet. Once it is approved, send the same code again (your entries are kept).",
  "errc.RESET_CODE_INVALID": "The code or email address is wrong, or the code has expired (it lasts 24 hours). Check them again, or ask the security department head to issue a new code.",
  "pwr.link": "Reset password with a code",
  "pwr.title": "Reset password with a code",
  "pwr.intro": "Use the reset code the security department head gave you to choose a new password.",
  "pwr.email": "Email address",
  "pwr.code": "Reset code",
  "pwr.codeHint": "Capital letters and hyphens do not matter.",
  "pwr.new": "New password",
  "pwr.newHint": "Avoid a password you use elsewhere, and make it hard to guess. If it does not meet the rules, the reason appears under this field.",
  "pwr.confirm": "New password (again)",
  "pwr.sep": ". ",
  "pwr.submit": "Set password",
  "pwr.submitting": "Saving…",
  "pwr.back": "Back to sign in",
  "pwr.err.emailRequired": "Enter your email address",
  "pwr.err.codeRequired": "Enter the reset code",
  "pwr.err.newRequired": "Enter a new password",
  "pwr.err.mismatch": "Enter the same password as above",
  "pwr.err.invalid": "The code or email address is wrong, or the code has expired (it lasts 24 hours). Check them again, or ask the security department head to issue a new code. Your input is kept.",
  "pwr.err.policy": "The password does not meet the rules. What to fix is written under “New password”. Your input is kept.",
  "pwr.err.rate": "There were too many tries in a short time, so please wait a little. Then press “Set password” again. Your input is kept.",
  "pwr.err.network": "Could not reach the server. Your input is kept. Check your connection and press “Set password” again.",
  "pwr.err.other": "The password could not be set. Your input is kept. Try again in a while, or contact the security department head.",
  "pwr.done": "Your password is set. Please sign in with the new password. You may see some guidance after signing in.",
};
